<template>
  <footer>
    <div class="container">
      <div class="mb-5">
        <FooterNav></FooterNav>
      </div>
      <p class="text-center"><small>Copyright © {{ nowYear }} 文曲星有限公司 All Rights Reserved.</small></p>
    </div>
  </footer>
</template>

<script>
import FooterNav from './FooterNav';
import moment from 'moment';
export default {
  name: 'WebFooter',
  data() {
    return {

    };
  },
  components: {
    FooterNav,
  },
  computed: {
    nowYear() {
      return moment().format('YYYY');
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/main.scss";
footer {
  padding: 6rem 0 2rem;
  background: $color-lightest-green;

  .links {
    margin-bottom: 4rem;
  }

  @media screen and (min-width: 768px) {
    padding: 8rem 0 2rem;
    .links {
      margin-bottom: 8rem;
    }
  }
}
</style>
